var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.hidden),expression:"!hidden"}],ref:"container",staticClass:"remote-scroller"},[_c('div',{ref:"control",class:{
          'remote-scroller-control': true,
          'remote-scroller-dragging': this.dragging,
          'remote-scroller-exclusive': this.exclusive
      }})])}
var staticRenderFns = []

export { render, staticRenderFns }